import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import localForage from 'localforage';
import Slider from '@material-ui/lab/Slider';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
// const { PieChart, Pie, Sector, Cell } = Recharts;
import {
  PieChart,
  Pie,
  // Sector,
  Cell,
} from 'recharts';

import googleBadge from './img/google-play-badge.png';
import appleBadge from './img/app-store-badge.png';
import foods from './foods';
import foodGroups from './groups';
import kcal from './kcal';
import logo from './logo.svg';

const storageKey = 'planetary';

const styles = theme => ({
  root: {
  },
  slider: {
    padding: `${theme.spacing.unit * 1}px 0`,
  },
  page: {
    maxWidth: 800,
    margin: '0 auto',
  },
  intro: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    padding: theme.spacing.unit * 2,
    textAlign: 'justify',
    position: 'relative',
  },
  heading: {
    // color: theme.palette.primary.main,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headingTitle: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingRight: theme.spacing.unit * 2,
  },
  primary: {
    fontWeight: 600,
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  subtitle: {
    // letterSpacing: 0,
    color: theme.palette.secondary.main,
    fontWeight: 300,
  },
  info: {
    fontStyle: 'italic',
    fontWeight: 300,
    textAlign: 'justify',
    maxWidth: 500,
    margin: '0 auto',
  },
  select: {
    margin: theme.spacing.unit,
  },
  selects: {
    margin: `${theme.spacing.unit}px 0`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    margin: `${theme.spacing.unit * 2}px auto`,
    // marginBottom: theme.spacing.unit * 1,
    fontStyle: 'italic',
    maxWidth: 500,
    textAlign: 'justify',
    padding: `0 ${theme.spacing.unit * 2}px`,
  },
  bottomDivider: {
    marginTop: theme.spacing.unit * 3,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  resetBtnContainer: {
    padding: theme.spacing.unit * 2,
    boxSizing: 'border-box',
    width: '100%',
    textAlign: 'center',
  },
  resetBtn: {

    // fontWeight: 600,
  },
  logo: {
    // marginRight: theme.spacing.unit,
    // marginTop: 4,
    // width: '90%',
    // height: 40,
    // boxSizing: 'border-box',
    flexGrow: 0,
    width: 100,
    height: 100,
    minWidth: 100,
    // marginLeft: theme.spacing.unit * 2,
    // top: theme.spacing.unit,
    // right: theme.spacing.unit,
    [theme.breakpoints.up('md')]: {
      // position: 'absolute',
    },
  },
  legend: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing.unit * 2,
  },
  legendItem: {
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    margin: `${theme.spacing.unit}px 0`,
    flexGrow: 1,
    flexBasis: '50%',

    [theme.breakpoints.up('md')]: {
      flexBasis: '25%',
    },
    // marginBottom: theme.spacing.unit,
  },
  legendBox: {
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
    // border: '1px solid black',
    marginRight: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
  },
  badgeSection: {
    textAlign: 'center',
  },
  badge: {
    maxHeight: 80,
    maxWidth: '50%',
    padding: 10,
    boxSizing: 'border-box',
  },
  moreBtnContainer: {
    textAlign: 'center',
    marginTop: theme.spacing.unit * 2,
  },
});


// const RADIAN = Math.PI / 180;
const SimplePieChart = ({ data, width }) => (
  <PieChart
    width={width}
    height={width}
    style={{ margin: 'auto', paddingRight: 12 }}
  >
    <Pie
      // test={console.log('PIE DATA', data)}
      data={data}
      dataKey="value"
      cx={width / 2}
      cy={width / 2}
      labelLine={false}
      outerRadius={(width / 2) - 16}
      // fill="#ff0000"
      startAngle={90}
      endAngle={450}
    >
      {
        data.map((entry, index) => <Cell key={data[index].name} fill={data[index].background || '#000'} />)
      }
    </Pie>
  </PieChart>
);
SimplePieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  width: PropTypes.number.isRequired,
};
let saveTimer = false;

const canChange = (i, values, moved, diff = 0) => !(
  foods[i].gramsMin === foods[i].gramsMax
    || (diff < 0 && values[i] === foods[i].gramsMax)
    || (diff > 0 && values[i] === foods[i].gramsMin)
    || (moved[i] && (values[i] === foods[i].gramsMax || values[i] === foods[i].gramsMin))
);


const total = (f, values, moved, exc, onlyDiff = false, diff = 0) => {
  const a = f.map((food, i) => ((exc === i || (onlyDiff && !canChange(i, values, moved, diff)))
    ? 0 : (food.kcal / food.grams * values[i]))).reduce((x, y) => x + y, 0);
  // console.log('total', a, f);
  return a;
};
const odp = v => Math.round(v * 2) / 2;
const getIngredients = (i, values, ratio = 1) => {
  // console.log(foods[i].title, values[i], foods[i].weights);
  let days = 1;
  const val = values[i] * ratio;

  if (!foods[i].weights || Object.values(foods[i].weights).length === 0) return false;
  // check if value is less than smallest weight. Then use multiple days
  const smallestWeight = foods[i].weights.sort((a, b) => a.weight - b.weight)[0].weight;
  if (odp(val / smallestWeight) < 1) {
    days = Math.ceil(smallestWeight / val);
  }
  // console.log('smallestWeight', smallestWeight, );

  // find weight with smallest MOD % for value
  const ing = foods[i].weights
    .sort((a, b) => ((val * days) % a.weight) - ((val * days) % b.weight));
  // console.log('ing', (values[i] * days) / ing[0][1], ing[0][0], days);
  return `(e.g. ${odp((val * days) / ing[0].weight)} ${odp((val * days) / ing[0].weight) === 1 ? ing[0].singular.toLowerCase() : ing[0].plural.toLowerCase()} ${days === 1 ? 'per day' : `every ${days} days`})`;
};
const baseAim = 2500;
const defaultValues = {
  ...foods.map((food, i) => [i, food.grams])
    .reduce((obj, [k, v]) => ({ ...obj, [k]: v }), {}),
  12: 11.4,
};
const save = (d) => {
  const {
    age,
    sex,
    activity,
    values,
  } = d;
  const data = {
    age,
    sex,
    activity,
    values,
  };
  // console.log('setItem', storageKey, JSON.stringify(data));
  localForage.setItem(storageKey, JSON.stringify(data));
};

class App extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      values: defaultValues,
      pieValues: defaultValues,
      // aim: 2500,
      moved: {},
      dragging: false,
      width: 300,
    };
    this.containerNode = false;
    // document.addEventListener('pause', this.saveCurrent, false);
    // window.addEventListener('beforeunload', this.saveCurrent, false);

    localForage.getItem(storageKey, (err, data) => {
      const val = JSON.parse(data) || {};
      this.setState({
        open: true,
        values: val.values || defaultValues,
        sex: val.sex,
        activity: val.activity,
        age: val.age,
      });
      // console.log('GET', data);
    });
  }

  componentDidMount() {
    this.measure();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { width } = this.state;
    // console.log('widths', width, nextState.width, this.containerNode.offsetWidth);
    return width !== this.containerNode.offsetWidth
      || JSON.stringify(this.state) !== JSON.stringify(nextState);
  }

  componentDidUpdate() {
    this.measure();
  }

  getKcal() {
    const { sex, activity, age } = this.state;
    if (kcal[sex || 'f'] && kcal[sex || 'f'][activity || 1] && kcal[sex || 'f'][activity || 1][age || 19]) return kcal[sex || 'f'][activity || 1][age || 19];
    return baseAim;
  }

  getTotal(v = false, m = false) {
    const { values, moved } = this.state;
    return Math.round(total(foods, (v || values), (m || moved)) || 0);
  }

  setSave(v) {
    this.setState(v);

    if (saveTimer) {
      clearTimeout(saveTimer);
    }
    saveTimer = setTimeout(() => {
      save(Object.assign({}, this.state || {}, v || {}));
    }, 100);
  }

  saveRef(ref) {
    this.containerNode = ref;
  }

  measure() {
    const { offsetWidth } = this.containerNode;
    // console.log('measure', offsetWidth);
    this.setState({
      width: offsetWidth,
    });
  }

  changeValue(i, value) {
    const { values, moved } = this.state;
    const diff = (value - values[i]) * foods[i].kcal / foods[i].grams;
    let per = (diff / total(foods, values, moved, i, true, diff)) || 0;
    // console.log('diff kcal', diff, this.state.values);
    // console.log('per', per);

    let vals = {
      ...Object.entries(values)
        .map(v => (!canChange(
          v[0],
          values,
          moved,
          diff,
        ) ? v
          : [
            v[0],
            Math.min(Math.max(v[1] * (1 - per), foods[v[0]].gramsMin), foods[v[0]].gramsMax) || 0,
          ]))
        .reduce((obj, [k, v]) => ({ ...obj, [k]: v }), {}),
      [i]: value,
    };
    // getIngredients(i, values);
    if (Object.entries(vals)
      .filter(v => v[1] < foods[v[0]].gramsMin || v[1] > foods[v[0]].gramsMax).length > 0) {
      // console.log('NOPE', Object.entries(vals)
      //  .filter(v => v[1] < foods[v[0]].gramsMin || v[1] > foods[v[0]].gramsMax));
      return false;
    }
    const mov = {
      ...moved,
      [i]: true,
    };

    if (Math.abs(this.getTotal(vals, mov) - baseAim) > 5) {
      // return false;
      // this time ignoring ones that have been moved before
      per = diff / total(foods, values, {}, i, true, diff);
      vals = {
        ...Object.entries(values)
          .map(v => (!canChange(
            v[0],
            values,
            {},
            diff,
          ) ? v : [
              v[0],
              Math.min(Math.max(v[1] * (1 - per), foods[v[0]].gramsMin), foods[v[0]].gramsMax) || 0,
            ]))
          .reduce((obj, [k, v]) => ({ ...obj, [k]: v }), {}),
        [i]: value,
      };
      if (Math.abs(this.getTotal(vals, {}) - baseAim) > 5) return false;
    }

    // if (Math.abs(this.getTotal(values, moved) - baseAim) > 5) return false;

    // console.log('change', vals, mov);
    return this.setSave({
      values: vals,
      moved: mov,
    });
  }

  // saveRef = ref => this.contentRef = ref;

  render() {
    // console.log(this.state.moved);
    const { classes } = this.props;
    const {
      age,
      sex,
      activity,
      values,
      pieValues,
      dragging,
      width,
      dragStart,
      open,
    } = this.state;

    // console.log('values', dragging, values);
    const pie = foodGroups.map(g => ({
      name: g.title,
      value: g.foods.map(f => pieValues[f]).reduce((a, b) => a + b, 0),
      background: g.background,
      text: g.text,
    }));
    const isBrowser = !window.cordova;
    // console.log('process.argv', process.argv);
    // console.log(JSON.stringify(pie));
    if (!open) return '';
    return (
      <div>
        <div className={classes.intro}>
          <MuiThemeProvider theme={createMuiTheme({ typography: { useNextVariants: true }, palette: { type: 'dark', primary: { light: '#b35000', main: '#b35000', dark: '#b35000' } } })}>
            <div className={classes.page} ref={this.saveRef.bind(this)}>
              <div className={classes.heading}>
                <Typography variant="h3" className={classes.headingTitle}>
                  <span>Planetary&nbsp;</span>
                  <span className={classes.noWrap}>Health Diet</span>
                </Typography>
                <img src={logo} alt="Planetary Health Diet logo" className={classes.logo} />
              </div>

              <div className={classes.selects}>
                <FormControl className={classes.select}>
                  <InputLabel htmlFor="name-readonly">Age</InputLabel>
                  <Select
                    value={age || 19}
                    onChange={event => this.setSave({ age: event.target.value })}
                  >
                    <MenuItem value={2}>2-3</MenuItem>
                    <MenuItem value={4}>4-8</MenuItem>
                    <MenuItem value={9}>9-13</MenuItem>
                    <MenuItem value={14}>14-18</MenuItem>
                    <MenuItem value={19}>19-30</MenuItem>
                    <MenuItem value={31}>31-50</MenuItem>
                    <MenuItem value={51}>51+</MenuItem>
                  </Select>
                </FormControl>
                <FormControl className={classes.select}>
                  <InputLabel htmlFor="name-readonly">Sex</InputLabel>
                  <Select
                    value={sex || 'f'}
                    onChange={event => this.setSave({ sex: event.target.value })}
                  >
                    <MenuItem value="m">Male</MenuItem>
                    <MenuItem value="f">Female</MenuItem>
                  </Select>
                </FormControl>
                <FormControl className={classes.select}>
                  <InputLabel htmlFor="name-readonly" className={classes.noWrap}>Physical activity</InputLabel>
                  <Select
                    value={activity || 2}
                    onChange={event => this.setSave({ activity: event.target.value })}
                  >
                    <MenuItem value={1}>Low</MenuItem>
                    <MenuItem value={2}>Moderate</MenuItem>
                    <MenuItem value={3}>High</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <Typography className={classes.info}>
                {'Move the sliders below to personalize your planetary health diet in line with the recommended quantities and ratios taken from the official report.'}
              </Typography>

              {isBrowser && (
                <Typography className={classes.moreBtnContainer}>
                  <Button
                    variant="outlined"
                    component="a"
                    href="about/"
                  >
                    What is the Planetary Health Diet?
                  </Button>
                </Typography>
              )}

              <Typography variant="subtitle1">
                {false && `What should we be eating for a healthy diet that's also sustainable for our planet's future? 
                By 2050 there will be nearly 10 billion people on the planet. This largely plant-based diet allows 
                for optional meat, fish, eggs and dairy.`}
              </Typography>
            </div>
          </MuiThemeProvider>
        </div>
        <List className={classes.page}>
          {foods.map((food, i) => (
            <ListItem key={food.title}>
              <ListItemText
                component="div"
                primary={food.subtitle ? (
                  <div>
                    {`${food.title} `}
                    <small className={classes.subtitle}>
                      {`(${food.subtitle})`}
                    </small>
                  </div>
                ) : food.title}
                secondary={(
                  <div>
                    {food.gramsMin !== food.gramsMax && (
                      <MuiThemeProvider
                        theme={
                          createMuiTheme(
                            {
                              typography: { useNextVariants: true },
                              palette: {
                                primary: {
                                  main: foodGroups
                                    .filter(g => g.foods.indexOf(i) >= 0)[0].background || '#000',
                                },
                              },
                            },
                          )
                        }
                      >
                        <Slider
                          value={values[i]}
                          min={food.gramsMin}
                          max={food.gramsMax}
                          step={food.grams === Math.round(food.grams) ? 1 : 0.1}
                          onChange={(event, value) => (
                            (dragging && ((new Date()).getTime() - dragStart) > 350) || isBrowser
                          ) && this.changeValue(i, value)}
                          onDragStart={() => this.setSave(
                            {
                              dragging: true,
                              dragStart: (new Date()).getTime(),
                            },
                          )}
                          onDragEnd={() => this.setSave({ dragging: false, pieValues: values })}
                          className={classes.slider}
                        />
                      </MuiThemeProvider>
                    )}
                    <div>
                      {`${Math.round(values[i] * this.getKcal() / baseAim) || 0}g `}
                      {values[i] > 0.1 && getIngredients(i, values, (this.getKcal() / baseAim))}
                    </div>
                  </div>
                )}
                secondaryTypographyProps={{ component: 'div' }}
                classes={{
                  primary: classes.primary,
                  secondary: classes.secondary,
                }}
              />
            </ListItem>
          ))}
        </List>
        <div className={classes.resetBtnContainer}>
          <Button
            variant="contained"
            color="primary"
            className={classes.resetBtn}
            disabled={Object.values(values).join(',') === Object.values(defaultValues).join(',')}
            onClick={() => this.setSave({ values: defaultValues, pieValues: defaultValues })}
          >
            Reset all
          </Button>
        </div>
        <Divider />
        <div className={classes.page}>
          <div className={classes.legend}>
            {foodGroups.map(g => (
              <div className={classes.legendItem} key={g.title}>
                <span style={{ backgroundColor: g.background || '#000' }} className={classes.legendBox} />
                <Typography style={{ color: g.background || '#000' }}>{g.title}</Typography>
              </div>
            ))}
          </div>
          <SimplePieChart
            data={pie}
            width={Math.min(width, 500)}
          />
        </div>
        <div>
          <Divider className={classes.bottomDivider} />
          <Typography className={classes.footer}>
            Diet recommendations: EAT–Lancet Commission.
          </Typography>
          <Typography className={classes.footer}>
            {'Daily calorie requirements: Estimated Energy Requirements (EER) from the Institute of Medicine Dietary Reference Intakes macronutrients report, 2002.'}
          </Typography>
          <Typography className={classes.footer}>
            {'Privacy Policy: We collect absolutely zero data from the app. All of your data is offline only and is stored solely on your phone and never sent to us or any third party.'}
          </Typography>
          {isBrowser && (
            <div className={classes.badgeSection}>
              <a href="https://itunes.apple.com/us/app/planetary-health-diet/id1450024339?pt=119228314&mt=8&ct=badge">
                <img src={appleBadge} alt="Download on the App Store" className={classes.badge} />
              </a>
              <a href="https://play.google.com/store/apps/details?id=uk.co.mento.planetary&referrer=utm_source%3Dwebsite%26utm_medium%3Dbadge">
                <img src={googleBadge} alt="Get it on Google Play" className={classes.badge} />
              </a>

            </div>
          )}
        </div>
      </div>
    );
  }
}
App.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(styles, { withTheme: true })(App);
